module.exports = __webpack_public_path__ + "f7ce82daf14dea56f8a22b67131f64d7.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/icons/build/fonts/spark-icon-fill.ttf?
// module id = 1408
// module chunks = 0